import { render, staticRenderFns } from "./MenuDivision.vue?vue&type=template&id=3cdfaf45&scoped=true&"
import script from "./MenuDivision.vue?vue&type=script&lang=ts&"
export * from "./MenuDivision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfaf45",
  null
  
)

export default component.exports